export const MAINTENANCE_PATH = ['/']

export const translationsTH = {
  title: '(ขณะนี้เว็บไซต์กำลังอยู่ในช่วง บำรุงรักษาและปรับปรุงระบบ เพื่อเพิ่มประสิทธิภาพ ความปลอดภัย และความเสถียรในการให้บริการแก่ผู้ใช้งานทุกท่านให้ดียิ่งขึ้น)',
  message: 'เว็บไซต์จะกลับมาเปิดให้บริการตามปกติ โดยเร็วที่สุด หลังจากการดำเนินการเสร็จสิ้นเรียบร้อย',
}
export const translationsEN = {
  title: 'Our website is currently undergoing system maintenance and upgrades.',
  message: 'The website will be back online and fully operational as soon as the maintenance is completed.',
}
